import { EventEmitter, OnInit } from '@angular/core';
import { OrdersFilters } from '@ml/orders/types/orders-filters';
import { FormControl } from '@angular/forms';
import { OrderStatus } from '@ml/orders/types/order';
var OrdersFiltersComponent = /** @class */ (function () {
    function OrdersFiltersComponent() {
        this.filter = new EventEmitter();
        this.statusControl = new FormControl();
        this.statuses = Object.values(OrderStatus).map(function (status) { return ({
            id: status,
            name: status
        }); });
    }
    Object.defineProperty(OrdersFiltersComponent.prototype, "_connection", {
        set: function (connection) {
            if (!connection) {
                this.statusControl.disable();
            }
            else {
                this.statusControl.enable();
            }
        },
        enumerable: true,
        configurable: true
    });
    OrdersFiltersComponent.prototype.ngOnInit = function () {
        if (this.customStatuses) {
            this.statuses = this.customStatuses;
        }
        this.statusControl.setValue(this.filters.status);
    };
    OrdersFiltersComponent.prototype.onSelectStatus = function (statuses) {
        var filters = new OrdersFilters(statuses);
        this.filter.emit(filters);
    };
    return OrdersFiltersComponent;
}());
export { OrdersFiltersComponent };
